import React, { forwardRef, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import {
  Button,
  Card,
  CardContent,
  // CardMedia,
  Typography,
  Box,
  Skeleton,
  Modal
} from '@mui/material';
import { ChevronLeft, ChevronRight, StarRateRounded } from '@mui/icons-material';
// import { PUBLIC_CMS_URL, IMAGE_DIR_PATH } from '../../../APIs/endpoint';
import moment from 'moment';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import StarVector from '../../../../src/assets/images/Start_Vector.jpg';

// import CustomButton from '../../Common/button';

const ReviewCardCommon = ({
  title,
  description,
  rating,
  category,
  user,
  date,
  // imageUrls,
  isLoader
}) => {
  // const settings = {
  //   dots: false,
  //   speed: 1000,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   infinite: imageUrls.length > 1,
  //   autoplay: imageUrls.length > 1,
  //   autoplaySpeed: 3000
  // };
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <>
      <Card
        onClick={handleOpen}
        sx={{
          maxWidth: '100%',
          // minHeight: 320,
          minHeight: 210,
          maxHeight: 372.75,
          height: 'unset',
          borderRadius: 2,
          m: 2,
          boxShadow: '10px 10px 30px 0px rgba(0, 0, 0, 0.16) !important',
          overflow: 'hidden',
          transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '15px 15px 40px 0px rgba(0, 0, 0, 0.2) !important',
            '& img': {
              transform: 'scale(1.1)'
            }
          }
        }}>
        {/* <Slider {...settings}>
          {isLoader ? (
            <Skeleton variant="rectangular" width="100%" height={112} />
          ) : imageUrls.length === 0 ? (
            <CardMedia
              component="img"
              image={''}
              alt="default image"
              sx={{
                maxHeight: 120,
                width: 280,
                objectFit: 'cover',
                transition: 'transform 0.3s ease-in-out'
              }}
            />
          ) : (
            imageUrls.map((imageUrl, index) => (
              <CardMedia
                key={index}
                component="img"
                image={`${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.REVIEW_LIST_PATH}${imageUrl}`}
                alt={`Image ${index}`}
                sx={{
                  maxHeight: 178,
                  width: 280,
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease-in-out'
                }}
              />
            ))
          )}
        </Slider> */}
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <StarRateRounded sx={{ color: 'gold', padding: '0', margin: '0' }} />
            <Typography
              sx={{
                ml: 0.5,
                fontFamily: 'gothamBold',
                fontSize: '12px',
                color: '#000000CC'
              }}>
              {isLoader ? <Skeleton variant="text" width={20} height={28} /> : <>{rating}</>}
            </Typography>
            {category &&
              category.length > 0 &&
              category.map((cat, index) => (
                <Button
                  key={index}
                  variant="outlined"
                  color="error"
                  size="small"
                  sx={{
                    ml: 1.5,
                    fontFamily: 'gothamBook',
                    fontSize: '10px'
                  }}>
                  {isLoader ? <Skeleton variant="text" width={60} height={25} /> : <>{cat}</>}
                </Button>
              ))}
          </Box>
          <Typography
            gutterBottom
            component="div"
            sx={{
              fontFamily: 'gothamBold',
              fontSize: '15px',
              lineHeight: '18px',
              color: '#000000CC',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis'
            }}>
            {isLoader ? <Skeleton variant="text" width="100%" height={18} /> : <>{title}</>}
          </Typography>
          <Typography
            maxHeight="60px"
            sx={{
              fontFamily: 'gothamBook',
              fontSize: '14px',
              lineHeight: '20px',
              color: '#00000080'
            }}>
            {isLoader ? (
              <Skeleton variant="text" width="100%" height={60} />
            ) : (
              <> {description.length > 100 ? description.slice(0, 100) + '...' : description}</>
            )}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'column',
              mt: 2,
              alignItems: 'flex-end'
            }}>
            <Typography
              sx={{
                fontFamily: 'gothamBold',
                fontSize: '14px',
                lineHeight: '20px',
                color: '#000000CC'
              }}>
              {isLoader ? <Skeleton variant="text" width={80} height={30} /> : <>- {user}</>}
            </Typography>
            <Typography
              sx={{
                fontFamily: 'gothamBook',
                fontSize: '12px',
                lineHeight: '20px',
                color: '#00000099'
              }}>
              {isLoader ? (
                <Skeleton variant="text" width={60} height={30} />
              ) : (
                <>{moment(date).format('MMM, YYYY')}</>
              )}
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}>
        <Fade in={open}>
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              width: { xs: '75%', sm: 500 },
              p: 3,
              pt: 6,
              outline: 'none'
            }}>
            <Button
              sx={{
                position: 'absolute',
                top: '-5px',
                right: '-12px',
                marginTop: '8px',
                color: '#000000CC'
              }}
              onClick={handleClose}>
              <CloseRoundedIcon />
            </Button>
            {/* <CardMedia
              component="img"
              image={`${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.REVIEW_LIST_PATH}${imageUrls[0]}`}
              alt={title}
              sx={{
                borderRadius: 2,
                objectFit: 'cover',
                mb: 3,
                height: { xs: '200px', sm: '240px' }
              }}
            /> */}

            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <StarRateRounded sx={{ color: 'gold', padding: '0', margin: '0' }} />
              <Typography
                sx={{
                  ml: 0.5,
                  fontFamily: 'gothamBold',
                  fontSize: '12px',
                  color: '#000000CC'
                }}>
                {isLoader ? <Skeleton variant="text" width={20} height={28} /> : <>{rating}</>}
              </Typography>
              <Button
                variant="outlined"
                color="error"
                size="small"
                sx={{ ml: 1.5, fontSize: '10px' }}>
                {category}
              </Button>
            </Box>

            <Typography
              variant="h6"
              sx={{
                fontFamily: 'gothamBold',
                fontSize: '16px',
                color: '#000000CC'
              }}>
              {title}
            </Typography>

            <Typography
              sx={{
                mt: 1,
                mb: 2,
                fontFamily: 'gothamBook',
                fontSize: '14px',
                lineHeight: '22px',
                color: '#00000099'
              }}>
              {description}
            </Typography>

            <Box sx={{ textAlign: 'right' }}>
              <Typography
                sx={{
                  fontFamily: 'gothamBold',
                  fontSize: '14px',
                  color: '#000000CC'
                }}>
                - {user}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'gothamBook',
                  fontSize: '12px',
                  color: '#00000099'
                }}>
                {moment(date).format('MMM, YYYY')}
              </Typography>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

const ReviewCard = forwardRef(({ reviewData, isLoader, isListing, isDetails }, ref) => {
  // const navigate = useNavigate();
  const [slider, setSlider] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const reviewDataLength = reviewData && reviewData.length;

  const getSlidesToShow = () => {
    const width = window.innerWidth;
    if (width < 600) return 1.2;
    if (width < 960) return 2.3;
    return 4;
  };

  const slidesToShow = getSlidesToShow();

  const goToPrev = () => {
    if (slider && currentIndex > 0) {
      slider.slickPrev();
      setCurrentIndex(currentIndex - 1);
    }
  };

  const goToNext = () => {
    if (slider && currentIndex < reviewData.length - 1) {
      slider.slickNext();
      setCurrentIndex(currentIndex + 1);
    }
  };

  const settings = {
    dots: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          centerMode: false
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.2
        }
      }
    ]
  };

  return (
    <>
      <Box
        ref={ref}
        sx={{
          overflow: isListing ? '' : 'hidden',
          marginTop: '16px',
          backgroundColor: isListing ? 'inherit' : '#ffffff',
          borderRadius: isListing ? '0px' : '10px',
          width: '100%'
        }}>
        <Box
          display="flex"
          justifyContent="space-between"
          width="100%"
          alignItems="center"
          mb={2}
          sx={{
            pl: {
              xs: '0px',
              sm: '10px',
              md: 'calc(10% - 20px)',
              lg: isListing || isDetails ? 'calc(10% - 50px)' : 'calc(10% - 20px)'
            }
          }}>
          <Typography
            sx={{
              flex: 1,
              fontSize: { xs: '20px', sm: '30px', md: '32px', lg: '32px' },
              fontFamily: 'gothamBold',
              paddingLeft: '15px !important'
            }}>
            Kesari Inbound Reviews
          </Typography>

          <Box
            sx={{
              display: { xs: 'none', sm: 'none', md: 'flex' },
              paddingRight: {
                xs: '18px',
                sm: '20px',
                md: '150px',
                lg: isListing ? '0px' : '180px'
              }
            }}>
            <ChevronLeft
              onClick={goToPrev}
              sx={{
                padding: '7px',
                boxSizing: 'content-box',
                width: '18px',
                height: '18px',
                border: '1px solid',
                borderColor: currentIndex === 0 ? '#0000004D' : '#000',
                borderRadius: '100%',
                color: currentIndex === 0 ? '#ccc' : '#000',
                mr: '14px',
                cursor: currentIndex === 0 ? 'default' : 'pointer',
                pointerEvents: currentIndex === 0 ? 'none' : 'auto'
              }}
            />
            <ChevronRight
              onClick={goToNext}
              sx={{
                padding: '7px',
                boxSizing: 'content-box',
                width: '18px',
                height: '18px',
                border: '1px solid',
                borderColor: currentIndex >= reviewDataLength - slidesToShow ? '#0000004D' : '#000',
                borderRadius: '100%',
                color: currentIndex >= reviewDataLength - slidesToShow ? '#ccc' : '#000',
                cursor: currentIndex >= reviewDataLength - slidesToShow ? 'default' : 'pointer',
                pointerEvents: currentIndex >= reviewDataLength - slidesToShow ? 'none' : 'auto'
              }}
            />
          </Box>
        </Box>

        <Box
          sx={{
            pl: {
              xs: '0px',
              sm: '10px',
              md: 'calc(10% - 20px)',
              lg: isListing || isDetails ? 'calc(10% - 50px)' : 'calc(10% - 20px)'
            }
          }}>
          <Typography
            component="div" // Changed to div to allow flex children
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap', // Ensures it wraps on very small screens
              fontSize: { xs: '14px', sm: '16px', md: '18px', lg: '20px' },
              fontFamily: 'gothamBook',
              lineHeight: { xs: '22px', sm: '22px', md: '32px', lg: '32px' },
              mb: 2,
              pl: '15px !important',
              mt: 1,
              color: '#000000B2'
            }}>
            4.5
            <Box
              component="img"
              src={StarVector}
              alt="star"
              sx={{
                width: { xs: '14px', sm: '16px', md: '18px', lg: '20px' },
                height: 'auto',
                mx: 0.5, // Horizontal margin (left and right of star)
                display: 'inline-block',
                verticalAlign: 'middle'
              }}
            />
            average across all Kesari Inbound tours
          </Typography>
        </Box>

        {reviewDataLength > 0 ? (
          <Box
            sx={{
              pl: {
                xs: '0px',
                sm: '10px',
                md: 'calc(10% - 30px)',
                lg: isListing || isDetails ? 'calc(10% - 50px)' : 'calc(10% - 20px)'
              }
            }}>
            <Slider {...settings} ref={(slider) => setSlider(slider)} className="card-list">
              {reviewData.map((review, index) => (
                <Box
                  key={index}
                  sx={{
                    padding: 1,
                    width: '350px'
                  }}>
                  <ReviewCardCommon
                    title={review.review_inbound_package_title}
                    description={review.review_inbound_description}
                    rating={review.review_inbound_rating}
                    category={review.review_inbound_tour_theme}
                    user={review.review_inbound_username}
                    date={review.review_inbound_date}
                    // imageUrls={review.review_inbound_image}
                    isLoader={isLoader}
                  />
                </Box>
              ))}
            </Slider>
          </Box>
        ) : (
          <Box className="travellife_title">
            <Typography
              sx={{
                fontSize: { xs: '22px', md: '44px' },
                fontFamily: 'gothamBold',
                textAlign: 'center',
                height: reviewDataLength === 0 ? '205px' : 'auto',
                alignContent: 'center'
              }}
              className="travellife_title_head">
              Coming Soon...!!!
            </Typography>
          </Box>
        )}
      </Box>
      {/* <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center'
        }}>
        <Box className="PerfectWeekend_btn_container">
          <CustomButton title="See More Reviews" onClick={() => navigate('/explore')} />
        </Box>
      </Box> */}
    </>
  );
});

ReviewCard.displayName = 'Reviews';

export default ReviewCard;
